<script>
import VueFeather from "vue-feather";
import DistributionClass from "@/entities/Distributions/DistributionClass";
export default {
  components: { VueFeather },
  emits: ['confirm', 'cancel'],
  props: { distribution: { type: Object } },
  setup(props, ctx) {
    const confirmEvent = () => { ctx.emit('confirm'); }
    const cancelEvent = () => { ctx.emit('cancel'); }
    return {
      confirmEvent,
      cancelEvent
    }
  },
  data() {
    return {
      inProgress: false,
      name: '',
      numbers: false,
      smart: false,
      noAnswered: false,
      visible: false,
      numbersToCloneCount: null,
      loadingCount: false
    }
  },
  watch: {
    numbers(n) {
      if (!n) {
        this.smart = false;
        this.noAnswered = false;
      }
      
      this.fetchNumbersCount();
    },
    smart() {
      this.fetchNumbersCount();
    },
    noAnswered() {
      this.fetchNumbersCount();
    }
  },
  methods: {
    fetchNumbersCount() {
      if (!this.numbers) {
        this.numbersToCloneCount = 0;
        return;
      }
      this.loadingCount = true;
      const Distribution = new DistributionClass(this);
      Distribution.countCloneNumbers(this.$props.distribution.id, this.smart, this.noAnswered, (count) => {
        this.numbersToCloneCount = count;
        this.loadingCount = false;
      }, () => {
        this.loadingCount = false;
      });
    },
    cloneDistribution() {
      this.inProgress = true;
      const Distribution = new DistributionClass(this);
      Distribution.cloneDistribution(
          this.$props.distribution.id,
          this.name,
          this.numbers,
          this.smart,
          this.noAnswered,
          (data) => {
        this.emitter.emit('distributions-list-changed');
        if (parseInt(data) > 0) {
          Distribution.listItem(data, (item) => {
            Distribution.numbersForm(item);
          }, null);
        }
        this.hireCancel();
      }, () => {
        this.inProgress = false;
      });
    },
    hireConfirm() {
      this.visible = false;
      setTimeout(() => {
        this.confirmEvent();
      }, 300);
    },
    hireCancel() {
      this.visible = false;
      setTimeout(() => {
        this.cancelEvent();
      }, 300);
    }
  },
  mounted() {
    this.visible = true;
    this.name = this.$props.distribution.name + ' - clone';
  }
}
</script>

<style>
.dialog-window .modal-body { background-color: white; height: 100vh; position: relative; }
.dialog-window {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2040;
  background-color: transparent;
}
.dialog-window_background {
  background-color: rgba(0,0,15,0.6);
  width: 100%;
  height: 100%;
}
.dialog-window_body_parent {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -10vh;
  left: 0;
}
.dialog-window_body {
  display: block;
  width: 500px;
  height: fit-content;
}
.dialog-window_body .card,
.dialog-window_body .card-body {
  border-radius: 15px;
  padding: 20px 30px;
}
.dialog-window_body .card {
  border: none;
  box-shadow: none;
}

.multiline {
  white-space: normal!important;
}
</style>

<template>
  <div class="dialog-window">
    <div class="dialog-window_background" @click="hireCancel"></div>
      <div class="dialog-window_body_parent d-flex flex-row align-items-center justify-content-center">
        <transition name="bounce">
          <div class="dialog-window_body" v-show="visible">
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-column align-items-center justify-content-start">
                <vue-feather :type="inProgress ? 'loader' : 'upload'" :size="50" :class="{'rotating': inProgress}" class="tx-info mg-rem-b-4"></vue-feather>
                <h4 class="tx-center">Клонирование рассылки</h4>
                <p class="tx-center">Выберите название для новой рассылки и отметьте нужно ли копировать номера из старой рассылки</p>
                <div class="form-group wd-100p-force pd-l-40 pd-r-40">
                  <input type="text" class="form-control" v-model="name">
                </div>
                <div class="form-group wd-100p-force pd-l-40 pd-r-40 mg-rem-t-2">
                  <label class="form-label multiline d-flex flex-row align-items-center justify-content-start">
                    <input type="checkbox" v-model="numbers">
                    <div class="fw-300-force mg-rem-l-1" style="display: inline-block;" >Скопировать номера</div>
                    <div v-if="numbers" class="mg-rem-l-1">
                      <vue-feather v-if="loadingCount" type="loader" size="14" class="rotating" />
                      <span v-if="!loadingCount && numbers">({{numbersToCloneCount}})</span>
                    </div>
                  </label>
                </div>
                <div class="form-group wd-100p-force pd-l-40 pd-r-40 mg-rem-t-2">
                  <label class="form-label multiline d-flex flex-row align-items-start justify-content-start">
                    <input type="checkbox" class="mg-t-2-force" :disabled="!numbers" v-model="smart">
                    <div class="fw-300-force mg-rem-l-1" style="display: inline-block;" >Умное копирование<br/><small>Будут скопированы только номера, по которым не было совершено вызовов</small></div>
                  </label>
                </div>
                <div class="form-group wd-100p-force pd-l-40 pd-r-40 mg-rem-t-2">
                  <label class="form-label multiline  d-flex flex-row align-items-start justify-content-start">
                    <input type="checkbox" class="mg-t-2-force" :disabled="!numbers" v-model="noAnswered">
                    <div class="fw-300-force mg-rem-l-1" style="display: inline-block;" >Проблемы дозвона<br/><small
                    >Будут скопированы только номера, со статусами: без ответа, занято, отмена вызова</small></div>
                  </label>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-between pd-l-40 pd-r-40 mg-t-30 wd-100p-force">
                  <a href="javascript:void(0)" class="btn btn-sm btn-outline-info" :disabled="!name || inProgress" @click="cloneDistribution">Скопировать</a>
                  <a href="javascript:void(0)" class="btn btn-sm btn-outline-secondary" :disabled="inProgress" @click="hireCancel">Отмена</a>
                </div>
              </div>

            </div>
          </div>
        </div>
        </transition>
      </div>
  </div>
</template>